import { Tab, Tabs, useTheme } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSearchParams } from 'react-router-dom';
import { MobileLayout } from '../../component/layout';
import { BikeleasingTabs } from './BikeleasingContent';
import { BikeleasingVendorContent, BikeleasingVendorTabs } from './BikeleasingVendorContent';

export const BikeleasingVendor: React.FC<{ tab: BikeleasingTabs }> = ({ tab }) => {
  const { t } = useTranslation('benefitModule');
  const theme = useTheme();
  const [searchParams, setSearchParams] = useSearchParams();
  const vendorTabParam = searchParams.get('vendorTab');
  const vendorTab =
    vendorTabParam === BikeleasingVendorTabs.MAP || vendorTabParam === BikeleasingVendorTabs.ONLINE
      ? vendorTabParam
      : BikeleasingVendorTabs.MAP;

  const handleChange = React.useCallback(
    (event: React.SyntheticEvent, newValue: BikeleasingVendorTabs) => {
      setSearchParams({
        tab,
        vendorTab: newValue,
      });
    },
    [tab, setSearchParams],
  );

  return (
    <MobileLayout
      iosOverloadScrollBackground={theme.palette.background.paper}
      header={
        <Tabs value={vendorTab} onChange={handleChange}>
          <Tab value={BikeleasingVendorTabs.MAP} label={t('extensions:bikeleasing_v2_benefit.vendorTabs.map')} sx={{ flex: 1 }} />
          <Tab value={BikeleasingVendorTabs.ONLINE} label={t('extensions:bikeleasing_v2_benefit.vendorTabs.online')} sx={{ flex: 1 }} />
        </Tabs>
      }
    >
      <BikeleasingVendorContent tab={vendorTab} />
    </MobileLayout>
  );
};
